import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Zap,
  LayoutDashboard,
  Sparkles,
  Users,
  Star,
  FileText,
  LogOut,
  Menu,
  X,
  Building2,
  ChevronRight,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './DashboardLayouts.css';

const businessNavItems = [
  { label: 'Dashboard', icon: LayoutDashboard, href: '/dashboards2' },
  { label: 'Create Content', icon: Sparkles, href: '/content' },
  { label: 'Leads', icon: Users, href: '/leadspage' },
  { label: 'Reviews', icon: Star, href: '/reviewspage' },
  { label: 'Lead Capture', icon: FileText, href: '/dashboard/capture' },
];

const adminNavItems = [
  { label: 'Overview', icon: LayoutDashboard, href: '/admin' },
  { label: 'Businesses', icon: Building2, href: '/admin/businesses' },
];

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut, isAdmin } = useAuth();

  const navItems = isAdmin ? adminNavItems : businessNavItems;

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="dashboard-layout" >
      {/* Mobile Header */}
      <header className="mobile-header">
        <div className="logo">
          <div className="logo-icon">
            <Zap color="white" size={20} />
          </div>
          <span className="title">SmartBiz</span>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </header>

      <div className="layout-flex" style={{
    overflowY: 'auto',
    height: '1000px',   
    paddingTop: '50px',
    width: '1200px'
  }}>
        {/* Sidebar */}
        <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="logo-section">
            <Link to={isAdmin ? '/admin' : '/dashboard'}>
              <div className="logo-icon">
                <Zap color="white" size={24} />
              </div>
              <div>
                <h1>SmartBiz</h1>
                <p>Growth Hub</p>
              </div>
            </Link>
          </div>

          <nav>
            {navItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link 
                  key={item.href} 
                  to={item.href} 
                  className={isActive ? 'active' : ''}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon />
                  <span>{item.label}</span>
                  {isActive && <ChevronRight className="chevron" />}
                </Link>
              );
            })}
          </nav>

          <div className="user-section">
            <div className="user-info">
              <div className="user-avatar">
                {user?.email?.charAt(0).toUpperCase()}
              </div>
              <div>
                <p>{user?.email}</p>
                <p>{isAdmin ? 'Administrator' : 'Business Owner'}</p>
              </div>
            </div>
            <button className="signout-btn" onClick={handleSignOut}>
              <LogOut size={16} /> Sign Out
            </button>
          </div>
        </aside>

        {/* Mobile overlay */}
        {sidebarOpen && (
          <div 
            className="mobile-overlay" 
            onClick={() => setSidebarOpen(false)} 
          />
        )}

        {/* Main content */}
        <main className="main-content">
          <div>{children}</div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;